<script setup lang="ts">
import type { SelectTriggerProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { SelectIcon, SelectTrigger, useForwardProps } from 'reka-ui';
import { ChevronDown } from '@lucide/vue';
import { cn } from '@/utils/shadcn';

const props = defineProps<SelectTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectTrigger
    data-slot="select-trigger"
    v-bind="forwardedProps"
    :class="cn(
      'flex items-center justify-between w-full px-3.5 py-2.5 text-sm text-text-primary bg-surface-card border border-border-default rounded-lg outline-none transition cursor-pointer',
      'focus:border-primary focus:ring-2 focus:ring-primary/10',
      'data-[placeholder]:text-text-tertiary',
      'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      props.class,
    )"
  >
    <slot></slot>
    <SelectIcon as-child>
      <ChevronDown class="size-4 shrink-0 text-text-tertiary transition-transform duration-200 data-[state=open]:rotate-180" />
    </SelectIcon>
  </SelectTrigger>
</template>
